import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { removeUndefined } from '../../util/general';
import { restoreAll } from '../restoreAll';
import { ProjectWithClientInfo } from '../../commonTypes/acs';
import { ProjectToUpdate } from '../../hooks/project/projectApi/useHttpPatchProject';

export interface ProjectsState {
    value: ProjectWithClientInfo[];
    showCreateProjectForm: boolean;
    showEditProjectForm: boolean;
}

const initialState: ProjectsState = {
    value: [],
    showCreateProjectForm: false,
    showEditProjectForm: false,
};

const projectsSlice = createSlice({
    name: 'projects',
    initialState,
    extraReducers: builder => builder.addCase(restoreAll, () => initialState),
    reducers: {
        setProjects: (state, action: PayloadAction<ProjectWithClientInfo[]>) => {
            state.value = action.payload;
        },
        addProject: (state, action: PayloadAction<ProjectWithClientInfo>) => {
            state.value.push({ ...action.payload });
        },
        setShowCreateProjectForm: (state, action: PayloadAction<boolean>) => {
            state.showCreateProjectForm = action.payload;
        },
        setShowEditProjectForm: (state, action: PayloadAction<boolean>) => {
            state.showEditProjectForm = action.payload;
        },
        editProject: (state, action: PayloadAction<ProjectToUpdate>) => {
            const { projectId, updateProject } = action.payload;
            const projectToUpdate = state.value.find(client => projectId === client.id);
            if (!projectToUpdate) {
                console.log('Project to be updated does not exits');
                return;
            }

            const filteredPayload = removeUndefined(updateProject);
            Object.assign(projectToUpdate, filteredPayload);
        },
        deleteProject: (state, action: PayloadAction<string>) => {
            state.value = state.value.filter(project => project.id !== action.payload);
        },
        removePending: (state, action: PayloadAction<ProjectWithClientInfo>) => {
            let found = false;

            state.value = state.value.map(project => {
                if (project.id !== action.payload.id) return project;
                found = true;
                return { ...project, pending: false };
            });

            if (found) return;

            state.value.push(action.payload);
        },
    },
});

export const { setProjects, addProject, editProject } = projectsSlice.actions;

export default projectsSlice.reducer;
